<template>
  <card>
    <div class="d-flex align-items-center justify-content-between brand_voice_panel">
      <div>
        <h4 slot="header" class="title mb-0">Additional sources settings</h4>
        <p slot="header" class="subtitle mb-0">Manage Additional sources used in your workspace</p>
      </div>
    </div>
    <RagAdditionalSourcesTable />
    <!-- <RagAdditionalSourcesTable @update="showUpdateForm" /> -->

  </card>
</template>
<script>
import RagAdditionalSourcesTable from './RagAdditionalSourcesTable.vue';
import { Dialog } from 'element-ui';

export default {
  components: {
    RagAdditionalSourcesTable,
    [Dialog.name]: Dialog,
  },
  props: {
    name: {
      type: String,
    },
    description: {
      type: String,
    },
    label: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      updatingBrandVoice: null,
      formComponentKey: 0
    };
  },
  computed: {
  },
  methods: {
  },
  mounted() {
  }
};
</script>
